import React from "react"
import { css } from "@emotion/react"
import styled from "@emotion/styled"

import classNames from "classnames"

export const Image = ({ image: { src, alt = "" }, ...props }) => (
  <img src={src.publicURL} alt={alt} {...props} />
)
